// global flash messages

const FLASH_KEY = "__flash_message__";

export type FlashMessage = {
  text: string;
  variant?: "default" | "error" | "success" | "warning" | "info";
  persist?: boolean;
};

export function setFlashMessage(msg: FlashMessage) {
  try {
    sessionStorage.setItem(FLASH_KEY, JSON.stringify(msg));
  } catch {
    // ignore
  }
}

export function consumeFlashMessage(): FlashMessage | null {
  try {
    const raw = sessionStorage.getItem(FLASH_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(FLASH_KEY);

    return JSON.parse(raw) as FlashMessage;
  } catch {
    return null;
  }
}
